/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Check_In_GuideInputs */

const en_doc_type_check_in_guide = /** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-In Guide`)
};

const id_doc_type_check_in_guide = /** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panduan Check-In`)
};

/** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */
const es_doc_type_check_in_guide = en_doc_type_check_in_guide;

/** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */
const fr_doc_type_check_in_guide = en_doc_type_check_in_guide;

/** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */
const de_doc_type_check_in_guide = en_doc_type_check_in_guide;

/** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */
const ja_doc_type_check_in_guide = en_doc_type_check_in_guide;

/** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */
const zh_doc_type_check_in_guide = en_doc_type_check_in_guide;

/** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */
const ar_doc_type_check_in_guide = en_doc_type_check_in_guide;

/** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */
const it_doc_type_check_in_guide = en_doc_type_check_in_guide;

/** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */
const ru_doc_type_check_in_guide = en_doc_type_check_in_guide;

/** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */
const pt_doc_type_check_in_guide = en_doc_type_check_in_guide;

/** @type {(inputs: Doc_Type_Check_In_GuideInputs) => LocalizedString} */
const ko_doc_type_check_in_guide = en_doc_type_check_in_guide;

/**
* | output |
* | --- |
* | "Check-In Guide" |
*
* @param {Doc_Type_Check_In_GuideInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_check_in_guide = /** @type {((inputs?: Doc_Type_Check_In_GuideInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Check_In_GuideInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_check_in_guide(inputs)
	if (locale === "es") return es_doc_type_check_in_guide(inputs)
	if (locale === "fr") return fr_doc_type_check_in_guide(inputs)
	if (locale === "de") return de_doc_type_check_in_guide(inputs)
	if (locale === "ja") return ja_doc_type_check_in_guide(inputs)
	if (locale === "zh") return zh_doc_type_check_in_guide(inputs)
	if (locale === "ar") return ar_doc_type_check_in_guide(inputs)
	if (locale === "id") return id_doc_type_check_in_guide(inputs)
	if (locale === "it") return it_doc_type_check_in_guide(inputs)
	if (locale === "ru") return ru_doc_type_check_in_guide(inputs)
	if (locale === "pt") return pt_doc_type_check_in_guide(inputs)
	return ko_doc_type_check_in_guide(inputs)
});